import CollectionForm from "./collection-form";

export default CollectionForm;